import styled from 'styled-components'

import { Cell } from '../Styled/Cell'

export const IconCell = styled(Cell)`
	margin-right: 8px;
	display: flex;
	align-items: center;
`
